<app-case-form-section-container
  [iconClass]="'bi bi-people'"
  [title]="'label.management_team'"
>
  <div class="d-flex justify-content-start mb-3" *ngIf="isAdmin">
    <button class="btn btn-primary default-button" (click)="openAddMemberModal()">
      <i class="bi bi-plus"></i> {{ 'buttons.add_new_member' | translate }}
    </button>
  </div>

  <div class="row">
    <div
      *ngFor="let user of selectedUsers; let i = index"
      class="col-md-4 d-flex align-items-center justify-content-between mb-3"
    >
    <div class="d-flex align-items-center justify-content-between gap-2 w-100">
      <app-profile-information
        [userName]="user.fullName"
        [userEmail]="user.email"
        [userRegion]="user.country"
        [userIconClass]="'bi bi-person-circle'"
        class="flex-grow-1 text-truncate"
      ></app-profile-information>
      <i
        *ngIf="isAdmin"
        class="bi bi-x-circle remove-icon ms-2"
        (click)="removeUser(i)"
        style="cursor: pointer; font-size: 1.5rem; white-space: nowrap;"
      ></i>
    </div>
   </div>
  </div>
</app-case-form-section-container>

<ng-template #addMemberBody>
  <app-select-form-field
  formControlName="teamDropdown"
  [items]="availableUsers"
  [bindLabel]="'fullName'"
  [bindValue]="'id'"
  (onSelectEvent)="onSelectTeamMember($event)"
  [placeholder]="'Select a team member'"
  [searchable]="true"
  [clearable]="true"
  (onSearchEvent)="searchAvailableUsers('search',$event.term, $event.page, $event.take)"
  [externalSearch]="true"
  [customClass]="'dropdown-field'"
  (onScrollEvent)="searchAvailableUsers('scroll',$event.term, $event.page, $event.take)"
  (onClearEvent)="searchAvailableUsers('search','',0,50)"
></app-select-form-field>

<div class="mt-3">
  <div
    *ngFor="let user of selectedDropdownUsers"
    class="d-flex align-items-center justify-content-between mb-3"
  >
    <app-profile-information
      *ngIf="user"
      [userName]="user.fullName"
      [userEmail]="user.email"
      [userRegion]="user.country"
      [userIconClass]="'bi bi-person-circle'"
      class="w-100"
    ></app-profile-information>
  </div>
</div>
</ng-template>
